import { MultiValuedListItems } from '../../../../../MultiValuedList'

import * as styles from './ListItems.module.css'

function ListItems(props) {
  return <MultiValuedListItems {...props} className={styles.ListItems} />
}

export default ListItems
